var _effectorFileName = "/src/widgets/layouts/main/components/header/header.tsx";
import dynamic from 'next/dynamic';
import { usePathname } from 'next/navigation';
import { Logo } from '@/shared/components/logo';
import { ThemeToggle } from '@/shared/components/theme-toggle';
export const Header = () => {
  const Sidebar = dynamic(() => import('@/widgets/layouts/main/components/sidebar').then(components => components.Sidebar));
  const pathname = usePathname();
  return <header className="fixed top-0 z-50 w-full border-b border-border/40 bg-background/95 py-4 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container">
        <div className="flex items-center justify-between">
          <Logo />

          <div className="flex items-center gap-6">
            <div className="hidden sm:block">
              <ThemeToggle />
            </div>

            <div className="block sm:hidden">
              <Sidebar />
            </div>
          </div>
        </div>
      </div>
    </header>;
};